import '../assets/NcColorPicker-CCqpXoam.css';
import { defineComponent, ref, computed } from "vue";
import { h as mdiDotsHorizontal, i as mdiCloseCircleOutline, a as mdiCheck, j as mdiArrowLeft } from "./mdi-CKSXwCsV.mjs";
import { useVModel } from "@vueuse/core";
import { Chrome } from "vue-color";
import { N as NcButton } from "./NcButton-D3CaJu1f.mjs";
import { N as NcIconSvgWrapper } from "./NcIconSvgWrapper-BCVwmZN2.mjs";
import { N as NcPopover } from "./NcPopover-nzbq2IjT.mjs";
import { u as useModelMigration } from "./useModelMigration-DBUi8saj.mjs";
import { r as register, a as t } from "./_l10n-DSLCwJSN.mjs";
import { d as defaultPalette, a as COLOR_BLACK, b as COLOR_WHITE } from "./colors-BMiIMYXK.mjs";
import { c as createElementId } from "./createElementId-5skgwxOP.mjs";
import { l as logger } from "./logger-D3RVzcfQ.mjs";
import { n as normalizeComponent } from "./_plugin-vue2_normalizer-DU4iP6Vu.mjs";
register();
var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
const __default__ = {
  model: {
    event: "update:modelValue",
    prop: "modelValue"
  }
};
const _sfc_main = /* @__PURE__ */ defineComponent(__spreadProps(__spreadValues({}, __default__), {
  __name: "NcColorPicker",
  props: {
    advancedFields: { type: Boolean },
    clearable: { type: Boolean },
    container: { default: "body" },
    modelValue: { default: "" },
    value: { default: void 0 },
    open: { type: Boolean },
    palette: { default: () => [] },
    paletteOnly: { type: Boolean }
  },
  emits: ["submit", "close", "update:modelValue", "update:value"],
  setup(__props, { emit }) {
    const props = __props;
    const currentColor = useModelMigration("value", "update:value", true);
    const modelOpen = useVModel(props, "open", emit, { passive: true, eventName: "update:open" });
    const HEX_REGEX = /^#([a-f0-9]{3}|[a-f0-9]{6})$/i;
    const id = createElementId();
    const advanced = ref(false);
    const normalizedPalette = computed(() => {
      var _a;
      let palette = props.palette;
      for (const color of palette) {
        if (typeof color === "string" && !color.match(HEX_REGEX) || typeof color === "object" && !((_a = color.color) == null ? void 0 : _a.match(HEX_REGEX))) {
          logger.error("[NcColorPicker] Invalid palette passed", { color });
          palette = [];
          break;
        }
      }
      if (palette.length === 0) {
        palette = props.clearable ? [...defaultPalette, COLOR_BLACK, COLOR_WHITE] : [...defaultPalette];
      }
      return palette.map((item) => ({
        color: typeof item === "object" ? item.color : item,
        name: typeof item === "object" && item.name ? item.name : t("A color with a HEX value {hex}", { hex: typeof item === "string" ? item : item.color })
      }));
    });
    function handleConfirm(hideCallback) {
      emit("submit", currentColor.value);
      hideCallback();
      advanced.value = false;
    }
    function toggleColor(color) {
      color = typeof color === "string" ? color : color.color;
      if (props.clearable && currentColor.value === color) {
        currentColor.value = void 0;
      } else {
        currentColor.value = color;
      }
    }
    function pickCustomColor(color) {
      currentColor.value = color.hex;
    }
    function getContrastColor(color) {
      return calculateLuma(color) > 0.5 ? COLOR_BLACK.color : COLOR_WHITE.color;
    }
    function calculateLuma(color) {
      const [red, green, blue] = hexToRGB(color);
      return (0.2126 * red + 0.7152 * green + 0.0722 * blue) / 255;
    }
    function hexToRGB(hex) {
      const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
      return result ? [parseInt(result[1], 16), parseInt(result[2], 16), parseInt(result[3], 16)] : [0, 0, 0];
    }
    return { __sfc: true, props, emit, currentColor, modelOpen, HEX_REGEX, id, advanced, normalizedPalette, handleConfirm, toggleColor, pickCustomColor, getContrastColor, calculateLuma, hexToRGB, mdiArrowLeft, mdiCheck, mdiCloseCircleOutline, mdiDotsHorizontal, Chrome, NcButton, NcIconSvgWrapper, NcPopover, t };
  }
}));
var _sfc_render = function render() {
  var _vm = this, _c = _vm._self._c, _setup = _vm._self._setupProxy;
  return _c(_setup.NcPopover, _vm._g(_vm._b({ attrs: { "shown": _setup.modelOpen, "container": _vm.container, "popup-role": "dialog" }, on: { "update:shown": function($event) {
    _setup.modelOpen = $event;
  }, "apply-hide": function($event) {
    return _setup.emit("close");
  } }, scopedSlots: _vm._u([{ key: "trigger", fn: function(slotProps) {
    return [_vm._t("default", null, null, slotProps)];
  } }, { key: "default", fn: function(slotProps) {
    var _a;
    return [_c("div", { staticClass: "color-picker", class: {
      "color-picker--advanced-fields": _setup.advanced && _vm.advancedFields,
      "color-picker--clearable": _vm.clearable
    }, attrs: { "role": "dialog", "aria-modal": "true", "aria-label": _setup.t("Color picker") } }, [_c("Transition", { attrs: { "name": "slide", "mode": "out-in" } }, [!_setup.advanced ? _c("div", { staticClass: "color-picker__simple" }, [_vm._l(_setup.normalizedPalette, function({ color, name }, index) {
      return _c("label", { key: index, staticClass: "color-picker__simple-color-circle", class: { "color-picker__simple-color-circle--active": color === _setup.currentColor }, style: {
        backgroundColor: color,
        color: _setup.getContrastColor(color)
      } }, [_c("span", { staticClass: "hidden-visually" }, [_vm._v(" " + _vm._s(color) + " -- " + _vm._s(_setup.currentColor) + " ")]), color === _setup.currentColor ? _c(_setup.NcIconSvgWrapper, { attrs: { "path": _setup.mdiCheck } }) : _vm._e(), _c("input", { staticClass: "hidden-visually", attrs: { "type": "radio", "aria-label": name, "name": "color-picker-".concat(_setup.id) }, domProps: { "checked": color === _setup.currentColor }, on: { "click": function($event) {
        return _setup.toggleColor(color);
      } } })], 1);
    }), _vm.clearable ? _c("label", { staticClass: "color-picker__clear", attrs: { "title": _setup.t("No color") } }, [_c(_setup.NcIconSvgWrapper, { attrs: { "size": _setup.currentColor ? 28 : 34, "path": _setup.mdiCloseCircleOutline } }), _c("input", { staticClass: "hidden-visually", attrs: { "type": "radio", "aria-label": _setup.t("No color"), "name": "color-picker-".concat(_setup.id) }, domProps: { "checked": !_setup.currentColor }, on: { "click": function($event) {
      _setup.currentColor = void 0;
    } } })], 1) : _vm._e()], 2) : _c(_setup.Chrome, { staticClass: "color-picker__advanced", attrs: { "disable-alpha": true, "disable-fields": !_vm.advancedFields, "value": (_a = _setup.currentColor) != null ? _a : "#000000" }, on: { "input": _setup.pickCustomColor } })], 1), !_vm.paletteOnly ? _c("div", { staticClass: "color-picker__navigation" }, [_setup.advanced ? _c(_setup.NcButton, { attrs: { "aria-label": _setup.t("Back"), "title": _setup.t("Back"), "variant": "tertiary" }, on: { "click": function($event) {
      _setup.advanced = false;
    } }, scopedSlots: _vm._u([{ key: "icon", fn: function() {
      return [_c(_setup.NcIconSvgWrapper, { attrs: { "directional": "", "path": _setup.mdiArrowLeft } })];
    }, proxy: true }], null, true) }) : _c(_setup.NcButton, { attrs: { "aria-label": _setup.t("More options"), "title": _setup.t("More options"), "variant": "tertiary" }, on: { "click": function($event) {
      _setup.advanced = true;
    } }, scopedSlots: _vm._u([{ key: "icon", fn: function() {
      return [_c(_setup.NcIconSvgWrapper, { attrs: { "path": _setup.mdiDotsHorizontal } })];
    }, proxy: true }], null, true) }), _c(_setup.NcButton, { attrs: { "variant": "primary" }, on: { "click": function($event) {
      return _setup.handleConfirm(slotProps.hide);
    } } }, [_vm._v(" " + _vm._s(_setup.t("Choose")) + " ")])], 1) : _vm._e()], 1)];
  } }], null, true) }, "NcPopover", _vm.$attrs, false), _vm.$listeners));
};
var _sfc_staticRenderFns = [];
var __component__ = /* @__PURE__ */ normalizeComponent(
  _sfc_main,
  _sfc_render,
  _sfc_staticRenderFns,
  false,
  null,
  "01d41e75"
);
const NcColorPicker = __component__.exports;
export {
  NcColorPicker as N
};
//# sourceMappingURL=NcColorPicker-DpLU-oKM.mjs.map
